<script>
  import { onMount, onDestroy, createEventDispatcher } from 'svelte';
  import { ignore } from './tools';
  import { External, M } from '../external';

  export let data = {},
    onChange = ignore,
    thirdPartyMarketing = true,
    label, description;

  let ui, uid = Math.random();

  let lists = {
    mailchimp: thirdPartyMarketing && External.Website.isMailchimpEnabled(),
    mailerlite: thirdPartyMarketing && External.Website.isMailerliteEnabled(),
    moosend: thirdPartyMarketing && External.Website.isMoosendEnabled(),
    aweber: thirdPartyMarketing && External.Website.isAweberEnabled(),
    getresponse: thirdPartyMarketing && External.Website.isGetResponseEnabled(),
    activecampaign: thirdPartyMarketing && External.Website.isActiveCampaignEnabled()
//    marketingLists: Website.isMarketingEnabled()
  };

  let selectList = (type) => {
    let titles = {
      Mailchimp: M.SELECT_MAILCHIMP_LISTS,
      Mailerlite: M.SELECT_MAILERLITE_LISTS,
      Moosend: M.SELECT_MOOSEND_LISTS,
      Aweber: M.SELECT_AWEBER_LISTS,
      GetResponse: M.SELECT_GETRESPONSE_LISTS,
      ActiveCampaign: M.SELECT_ACTIVECAMPAIGN_LISTS,
      Marketing: M.MARKETING_LISTS
    };

    let descriptions = {
      Mailchimp: M.FORMS_SELECT_MAILCHIMP_LISTS_DESC,
      Mailerlite: M.SELECT_MAILERLITE_LISTS_FORM_DESC,
      Moosend: M.SELECT_MOOSEND_LISTS_FORM_DESC,
      Aweber: M.SELECT_AWEBER_LISTS_FORM_DESC,
      GetResponse: M.SELECT_GETRESPONSE_LISTS_FORM_DESC,
      ActiveCampaign: M.SELECT_ACTIVECAMPAIGN_LISTS_FORM_DESC,
      Marketing: M.MARKETING_LISTS
    };

    let listPicker = External.Website['select' + type + 'Lists'];
    let key = type.substring(0, 1).toLowerCase() + type.substring(1).toLowerCase() + 'Lists';
    let opts = {
      lists: data[key] || [],
      title: titles[type],
      description: descriptions[type],
      onSelect: function(newLists) {
        data[key] = newLists;
        onChange();
        if (key === 'marketingLists' && (!newLists || !newLists.length)) {
          data.enableDoubleOptIn = false;
        }
      }
    };
    listPicker.call(External.Website, opts);
  };

  let selectTags = () => {
    data.tags = data.tags || [];
    let selectedTags = data.tags.map(lbl => External.Website.crmTags.find(tag => tag.label === lbl)).filter(tag => !!tag);
    External.UITools.selectTags(selectedTags, (newTags) => {
      data.tags = newTags.map(tag => tag.label);
      onChange();
    }, true);
  };

  onMount(() => {
    data.tags = data.tags || [];
  });
</script>

{#if label}
  <div class="popup-input-wrapper">
    <h5 class="mt-15">{label}</h5>
    <span class="explainer-text col20 f-left">{description}</span>
  </div>
{/if}
<div class="col20 f-left" bind:this={ui}>

  <div class="multiple-items-picker mb-5">
    <ul class="groups category-groups mb-15">
      <li>
        <a on:click={selectTags} rel="action" data-action="editProductCategories" class="middle-button gray">{M.SELECT_TAGS}</a>
      </li>
      <li data-role="count">{data.tags?.length} {data.tags?.length === 1 ? M.TAG : M.TAGS} {M.SELECTED}</li>
    </ul>
  </div>

  <div class="input-wrapper marketing-settings-wrapper mb-10">
    <div class="col20 mb-5 f-left gray-section product-select-wrapper">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto flex-1">{M.CONNECT_TO_EMAIL_MARKETING}</h4>
        <a class="text-link blue-text marketing-settings flex-none" on:click={() => selectList("Marketing")}>{M.SELECT_LISTS2}</a>
      </div>
    </div>
  </div>

  <div class="checkbox-wrapper col20 f-left mt-10" class:none={!(data.marketingLists && data.marketingLists.length)}>
    <input class="css-checkbox" type="checkbox" id="enableDoubleOptIn{uid}" bind:checked={data.enableDoubleOptIn} on:change={onChange} />
    <label for="enableDoubleOptIn{uid}" class="css-label">
      {M.ENABLE_DOUBLE_OPT_IN} <span>{M.ENABLE_DOUBLE_OPT_IN_DESC} </span>
    </label>
  </div>

  {#if lists.mailchimp}
    <div class="input-wrapper mailchimp-settings-wrapper mt-15">
      <a class="middle-button gray mailchimp-settings" on:click={() => selectList("Mailchimp")}>
        {M.MAILCHIMP_SETTINGS}
      </a>
    </div>
  {/if}
  {#if lists.mailerlite}
    <div class="input-wrapper mailerlite-settings-wrapper mt-15">
      <a class="middle-button gray mailerlite-settings" on:click={() => selectList("Mailerlite")}>
        {M.MAILERLITE_SETTINGS}
      </a>
    </div>
  {/if}
  {#if lists.moosend}
    <div class="input-wrapper moosend-settings-wrapper mt-15">
      <a class="middle-button gray moosend-settings" on:click={() => selectList("Moosend")}>
        {M.MOOSEND_SETTINGS}
      </a>
    </div>
  {/if}
  {#if lists.aweber}
    <div class="input-wrapper aweber-settings-wrapper mt-15">
      <a class="middle-button gray aweber-settings" on:click={() => selectList("Aweber")}>
        {M.AWEBER_SETTINGS}
      </a>
    </div>
  {/if}
  {#if lists.getresponse}
    <div class="input-wrapper getresponse-settings-wrapper mt-15">
      <a class="middle-button gray getresponse-settings" on:click={() => selectList("GetResponse")}>
        {M.GETRESPONSE_SETTINGS}
      </a>
    </div>
  {/if}
  {#if lists.activecampaign}
    <div class="input-wrapper activecampaign-settings-wrapper mt-15">
      <a class="middle-button gray activecampaign-settings" on:click={() => selectList("ActiveCampaign")}>
        {M.ACTIVECAMPAIGN_SETTINGS}
      </a>
    </div>
  {/if}
</div>
